import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const VehicleInspection = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Araç Muayenesi
      </Typography>
      <Paper sx={{ p: 2 }}>
        <Typography>Araç muayenesi burada görüntülenecek</Typography>
      </Paper>
    </Box>
  );
};

export default VehicleInspection;
